import { FC } from "react";
import {
    Text,
    Heading,
    Link,
    Container,
    Flex,
    List,
    ListItem,
    Icon,
} from "@smile2impress/components/relaunch";
import {
    IconProps,
    PhoneThinOutlineIcon,
    WhatsappThinOutlineIcon,
    TelegramOutlineIcon,
    MailThinOutlineIcon,
} from "@smile2impress/components";

import { ErrorPropsReferralItem, Site, Contact } from "content/error/types";
import { ContactTypes, SocialTypes } from "constants/enum";

export const ErrorReferral: FC<
    ErrorPropsReferralItem & { site?: Site; contacts?: Contact[] }
> = ({ title, description, contacts }) => {
    const iconsByName: Partial<Record<string, FC<IconProps>>> = {
        [ContactTypes.PHONE]: PhoneThinOutlineIcon,
        [SocialTypes.WA]: WhatsappThinOutlineIcon,
        [SocialTypes.TG]: TelegramOutlineIcon,
        [ContactTypes.EMAIL]: MailThinOutlineIcon,
    };
    return (
        <Container>
            <Flex
                position="relative"
                direction="column"
                justifyContent={["flex-start", "center"]}
                minH={["auto", "50vh"]}
                py={["100px", "24px"]}
                textAlign="center"
            >
                <Heading textStyle="display2" mb={["1", "2"]}>
                    {title}
                </Heading>
                <Text
                    maxWidth={["none", "480px"]}
                    mx="auto"
                    mb={["4", "5"]}
                    textStyle="body"
                    textAlign="center"
                >
                    {description}
                </Text>
                {contacts && contacts.length > 0 && (
                    <List
                        display={["block", "flex"]}
                        justifyContent="center"
                        width="100%"
                        maxW={["none", "580px"]}
                        mx="auto"
                        px={[0, "24px"]}
                        fontSize="17px"
                        lineHeight="24px"
                        fontWeight="500"
                    >
                        {contacts.map((contact) => (
                            <ListItem
                                key={contact.title}
                                width={["100%", "auto"]}
                                mr="24px"
                                borderBottom={[
                                    "0.5px solid rgba(66, 78, 88, 0.1)",
                                    "none",
                                ]}
                            >
                                <Link
                                    href={contact.link}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    flexDirection={["row", "row-reverse"]}
                                    width="100%"
                                    py={["16px", 0]}
                                >
                                    <Text mb="0">{contact.title}</Text>
                                    <Flex as="span" mr={[0, "18px"]}>
                                        <Icon as={iconsByName[contact.icon]} />
                                    </Flex>
                                </Link>
                            </ListItem>
                        ))}
                    </List>
                )}
            </Flex>
        </Container>
    );
};
